/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  profile,
  setFormData,
  formData,
  createInput,
  updateUserManagement,
  getSettings,
  showUserManagement,
  history,
  getRoleList,
  updating,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      name: profile.attributes.name || '',
      job_family: profile.attributes.job_family || '',
    });
  };
  const handleOnSubmit = e => {
    e.preventDefault();
    if (_.isObject(formData.photo)) {
      const args = {
        ...formData,
        start_date: `${moment(_.get(formData, 'start_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        end_date: `${moment(_.get(formData, 'end_date')).format(
          'YYYY-MM-DD HH:mm'
        )}:00`,
        photo: formData.photo.cdnUrl,
      };
      updateUserManagement(profile.id, args, ({ data }) => {
        setModal({ isOpen: false });
        getSettings();
        showUserManagement(profile.id);
        history.push(`/general-settings/institution/${_.get(data, 'id')}`);
      });
      return;
    }
    const args = {
      ...formData,
      start_date: `${moment(_.get(formData, 'start_date')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
      end_date: `${moment(_.get(formData, 'end_date')).format(
        'YYYY-MM-DD HH:mm'
      )}:00`,
    };
    updateUserManagement(profile.id, args, ({ data }) => {
      getSettings();
      setModal({ isOpen: false });
      showUserManagement(profile.id);
      history.push(`/general-settings/institution/${_.get(data, 'id')}`);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  useEffect(() => {
    getRoleList();
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-grousp">
            {createInput(
              { key: 'name', label: 'Institution Name:' },
              { required: true, placeholder: 'Input Institution name' }
            )}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateUserManagement: PropTypes.instanceOf(Function).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  getRoleList: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_SETTING}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_SETTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
